import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import Input, { clearForm, FormState, required, submitForm, useAreaInput, useTextInput } from "../../../components/input"
import Title from "../../../components/Title"
import { api } from "../../../env"

export default function CreateActivityTemplate() {

    const { id } = useParams()
    const navigate = useNavigate()
    const [state, setState] = useState(id ? FormState.VIEW : FormState.CREATE)

    const form = {
        name: useTextInput("Name", "label", [required]),
        description: useAreaInput("Description", "description", [required], 5)
    }

    useEffect(() => {
        if (id) {
            api.get(`activity-templates/${id}`)
                .then(res => {
                    form.name._setValue(res.data.name)
                    form.description._setValue(res.data.description)
                    setState(FormState.UPDATE)
                })
                .catch(() => navigate('..'))
        }
    }, [id])

    const handleSave = () => {
        const data = submitForm(form)
        if (!data) return
        const request = id
            ? api.put(`activity-templates/${id}`, data)
            : api.post('activity-templates', data)
        request
            .then(() => navigate('..'))
            .catch(err => console.log(err))
    }

    const handleDelete = () => {
        if (!id) return
        api.delete(`activity-templates/${id}`)
            .then(() => navigate('..'))
            .catch(err => console.log(err))
    }

    return (
        <div className="page-xl-centered standard-padding showing">
            <div className="flex space-between gap-xs center v-spacer-m">
                <Title>{id ? 'Edit Activity Template' : 'Create Activity Template'}</Title>
                <div className="flex gap-xs">
                    {id && <button className="solid-error" onClick={handleDelete}>Delete</button>}
                    <button className="solid" onClick={handleSave}>Save</button>
                </div>
            </div>
            <div className="card standard-padding-s flex columns gap-xs">
                <Input state={form.name} />
                <Input state={form.description} />
            </div>
        </div>
    )
}
